import styled from 'styled-components';
import { MediaQuery } from '../../../styles/mediaQuery';
import { respondTo } from '../../../styles/helpers/respondTo';

export const StyledWidgetContainer = styled.div<{ 'data-reverse'?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: ${(props) => (props['data-reverse'] ? 'column-reverse' : 'column')};

  @media ${respondTo(MediaQuery.Large)} {
    flex-direction: ${(props) => (props['data-reverse'] ? 'row-reverse' : 'row')};
  }
`;
